<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Construction Class Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.constrnCls }}</td>
          <td class="text-xs-left">{{ props.item.constrnClsDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.constrnCls)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Construction Class
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="constrnClsDialog" width="800px" lazy persistent v-if="checkAccess(['fireRatingReview'])">
      <v-card>
        <v-card-title>
          <span class="headline">Construction Class</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newConstrnCls">
                <v-text-field :label="labels.constrnCls" v-model="constrnClsForm.constrnCls" :error-messages="errors.collect('constrnCls')" data-vv-name="constrnCls" :data-vv-as="labels.constrnCls" v-validate="'required|param|max:2'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.constrnCls}}</v-subheader>
                <div class="title">{{constrnClsForm.constrnCls}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.constrnClsDesc" v-model="constrnClsForm.constrnClsDesc" :error-messages="errors.collect('constrnClsDesc')" data-vv-name="constrnClsDesc" :data-vv-as="labels.constrnClsDesc" v-validate="'required|entry|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Construction Class', value: 'constrnCls' },
        { text: 'Description', value: 'constrnClsDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        constrnCls: 'Construction Class*',
        constrnClsDesc: 'Description*'
      },
      newConstrnCls: false,
      constrnClsDialog: false,
      constrnClsForm: {
        constrnCls: null,
        constrnClsDesc: null
      },
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiUrl = this.fireMenu.getAllFireConstrnCls
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (result.data) {
            this.items = []
            data.map(fireConstrnCls => {
              const convertList = {
                constrnCls: fireConstrnCls.constrnCls,
                constrnClsDesc: fireConstrnCls.constrnClsDesc
              }
              this.items.push(convertList)
            })
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    doNew() {
      this.constrnClsDialog = this.newConstrnCls = true
      this.constrnClsForm.constrnCls = this.constrnClsForm.constrnClsDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    async doReview(constrnCls) {
      const apiURI = this.fireMenu.getFireConstrnCls
      if (apiURI) {
        const expand = {
          constrnCls
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.constrnClsForm.constrnCls = data.constrnCls.constrnCls
          this.constrnClsForm.constrnClsDesc = data.constrnCls.constrnClsDesc
          this.constrnClsDialog = true
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newConstrnCls) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.fireMenu.createFireConstrnCls
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.constrnClsForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.fireMenu.updateFireConstrnCls
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.constrnClsForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(constrnCls) {
      this.resetMessages()
      this.selectedId.id = constrnCls.constrnCls
      this.selectedId.text = constrnCls.constrnCls + ' - ' + constrnCls.constrnClsDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.fireMenu.deleteFireConstrnCls
      if (apiURI) {
        const expand = {
          constrnCls: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doClose() {
      this.constrnClsDialog = this.newConstrnCls = false
      this.constrnClsForm.constrnCls = this.constrnClsForm.constrnClsDesc = null
      this.resetValidator()
      this.resetMessages()
    }
  },
  created() {
    this.doFetch()
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    fireMenu() {
      return this.$store.state.fire.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
